import React, { useState, useEffect ,useRef} from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from "reactstrap";
import { useLocation } from "react-router-dom";
function ProactiveMonitoringDropDownOption(props) {
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState(null);
  useEffect(() => {
    const proactivePaths = [
      "/proactive-monitoring",
      "/pm-dashboard",
      "/proactive-ticket"
    ];
  
    const isInsideProactive = proactivePaths.some(path =>
      location.pathname.startsWith(path)
    );
  
    if (!isInsideProactive) {
      setSelectedItem(null);   // remove background when switching header
    }
  }, [location.pathname]);
  return (
    <div className={props.class}>
      <UncontrolledButtonDropdown>
        <DropdownToggle caret color="link" className="p-0">
        <div style={{ display: "inline-block" }}>
        {selectedItem !== null && props.buttons[selectedItem] 
    ? props.buttons[selectedItem].name 
    : "Proactive"}</div>
          {/* <div style={{ display: "inline-block" }}>
    {selectedItem !== null ? props.buttons[selectedItem].yes.name : "Proactive"}
</div> */}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-right">
        {props.buttons.map((button, i) => (
        <DropdownItem
          key={i}
          active={selectedItem === i}
          onClick={() => {
            setSelectedItem(i);
            button.action();
          }}
        >
          {button.name}
        </DropdownItem>
      ))}
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  );
}

export default ProactiveMonitoringDropDownOption;
